import { Box, FormControlLabel, RadioGroup, TextField } from '@mui/material';
import React from 'react';
import { StyledRadio } from '../../../components/styles/StyledInputs';
import { StyledTypography } from '../../../components/styles/styles';

interface ChatTimingControlsProps {
  timing: 'immediate' | 'unanswered';
  unansweredMinutes: number;
  disabled: boolean;
  onTimingChange: (timing: 'immediate' | 'unanswered') => void;
  onMinutesChange: (minutes: number) => void;
}

const ChatTimingControls: React.FC<ChatTimingControlsProps> = ({
  timing,
  unansweredMinutes,
  disabled,
  onTimingChange,
  onMinutesChange,
}) => (
  <RadioGroup
    value={timing}
    onChange={(e) => onTimingChange(e.target.value as 'immediate' | 'unanswered')}
  >
    <FormControlLabel
      value="immediate"
      control={<StyledRadio disabled={disabled} />}
      label={
        <StyledTypography sx={{ fontSize: '0.875rem' }}>
          Right away (when I&apos;m not already in that chat)
        </StyledTypography>
      }
    />
    <FormControlLabel
      value="unanswered"
      control={<StyledRadio disabled={disabled} />}
      label={
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
          <StyledTypography sx={{ fontSize: '0.875rem' }}>
            Only if I haven&apos;t read it within
          </StyledTypography>
          <TextField
            type="number"
            size="small"
            value={unansweredMinutes}
            onChange={(e) => {
              const parsed = Number.parseInt(e.target.value, 10);
              onMinutesChange(Number.isFinite(parsed) ? parsed : 2);
            }}
            inputProps={{ min: 1, max: 120 }}
            disabled={disabled || timing !== 'unanswered'}
            sx={{ width: '5rem' }}
          />
          <StyledTypography sx={{ fontSize: '0.875rem' }}>minutes</StyledTypography>
        </Box>
      }
    />
  </RadioGroup>
);

export default ChatTimingControls;
